"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = function _default(str) {
  if (typeof str !== 'string') {
    return false;
  }
  if (!/^(\d|\.)+$/.test(str)) {
    return false;
  }
  return !Number.isNaN(str) && !Number.isNaN(parseFloat(str));
};